import React, { Component } from 'react';
import { InfoWindow, Marker as GoogleMarker } from '@react-google-maps/api';

class Marker extends Component {
  constructor() {
    super();
    this.state = {
      showInfo: false,
    };
  }

  render() {
    const {
      marker, renderExtraInfo, onClick,
    } = this.props;
    const { showInfo } = this.state;

    return (
      <GoogleMarker
        key={marker.key}
        position={marker.position}
        onClick={() => { onClick(this); }}
        icon={marker.markerStyle}
        zIndex={marker.zIndex}
        label={{
          color: '#FFFFFF',
          text: marker.labelText,
          fontSize: '10px',
        }}
      >
        {showInfo && (
        <InfoWindow onCloseClick={() => this.setState({ showInfo: false })}>
          <div>
            <p>{marker.infoTitle}</p>
            <p>{marker.infoContent}</p>
            {marker.infoContentExtra
            && <p>{marker.infoContentExtra}</p>}

            {renderExtraInfo && renderExtraInfo()}

            {/* bikelocation-markers only */}
            {marker.vehicleEvents
            && marker.vehicleEvents.map((vehicleEvent) => (
              <p key={`${vehicleEvent.text}`}>
                {vehicleEvent.text}
                {' '}
                |
                {' '}
                <span style={vehicleEvent.availableStyle}>
                  {vehicleEvent.available}
                </span>
                {' '}
                |
                {' '}
                <span style={vehicleEvent.lockedStyle}>
                  {vehicleEvent.locked}
                </span>
                {' '}
                |
                {' '}
                <span>
                  {vehicleEvent.position}
                </span>
              </p>
            ))}
          </div>
        </InfoWindow>
        )}
      </GoogleMarker>
    );
  }
}

export default Marker;
